import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=3ba0e0ac"
import script from "./CartList.vue?vue&type=script&lang=ts"
export * from "./CartList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports